import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import WebsiteStructure from './pages/WebsiteStructure';
import WebsitePricing from './pages/WebsitePricing';
import FacebookTikTokAds from './pages/FacebookTikTokAds';
import GoogleAds from './pages/GoogleAds';
import './styles/global.css';

function App() {
  return (
    <Router>
      <div className="app">
        <Navbar />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/website-structure" element={<WebsiteStructure />} />
            <Route path="/website-pricing" element={<WebsitePricing />} />
            <Route path="/facebook-tiktok-ads" element={<FacebookTikTokAds />} />
            <Route path="/google-ads" element={<GoogleAds />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;